import React from 'react';
import styled from 'styled-components';
import theme from '../styles/theme';

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 24px;
  margin-bottom: 24px;
`;

const PageButton = styled.button<{ $active?: boolean }>`
  background: ${({ $active }) => ($active ? theme.colors.accentGradient : theme.colors.card)};
  color: ${({ $active }) => ($active ? '#fff' : theme.colors.textSecondary)};
  border: 1px solid ${({ $active }) => ($active ? 'transparent' : theme.colors.cardBorder)};
  padding: 9px 14px;
  min-width: 40px;
  cursor: pointer;
  border-radius: ${theme.radius.sm};
  font-size: ${theme.typography.small};
  font-weight: 600;
  transition: all ${theme.transitions.base};
  box-shadow: ${({ $active }) => ($active ? theme.shadows.glowSoft : theme.shadows.xs)};

  &:hover:not(:disabled) {
    background: ${({ $active }) =>
      $active ? theme.colors.accentGradient : 'rgba(255, 107, 107, 0.08)'};
    border-color: ${({ $active }) => ($active ? 'transparent' : 'rgba(255, 107, 107, 0.3)')};
    color: ${({ $active }) => ($active ? '#fff' : theme.colors.primary)};
    transform: translateY(-1px);
  }

  &:disabled {
    background: ${theme.colors.bg};
    color: ${theme.colors.textLight};
    border-color: ${theme.colors.border};
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }
`;

interface PaginationProps {
  itemsPerPage: number;
  totalItems: number;
  paginate: (pageNumber: number) => void;
  currentPage: number;
}

const Pagination: React.FC<PaginationProps> = ({
  itemsPerPage,
  totalItems,
  paginate,
  currentPage,
}) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <PaginationWrapper>
      <PageButton onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
        Previous
      </PageButton>
      {pageNumbers.map(number => (
        <PageButton
          key={number}
          onClick={() => paginate(number)}
          $active={number === currentPage}
        >
          {number}
        </PageButton>
      ))}
      <PageButton
        onClick={() => paginate(currentPage + 1)}
        disabled={currentPage === pageNumbers.length}
      >
        Next
      </PageButton>
    </PaginationWrapper>
  );
};

export default Pagination;
